/**
 * ValidationBadge Component
 * Shows error count on tabs or wizard steps
 */

import React from 'react';
import './ValidationBadge.css';

export interface ValidationBadgeProps {
  count: number;
}

/**
 * Small error count badge
 * Only renders when count > 0
 */
export const ValidationBadge: React.FC<ValidationBadgeProps> = ({ count }) => {
  if (count === 0) return null;

  return (
    <span className="af-validation-badge">
      {count}
    </span>
  );
};

ValidationBadge.displayName = 'ValidationBadge';
